<template>
  <BModal
    id="modalNonjob"
    ref="modalNonjob"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        class="m-auto"
      >
      <div class="font-semibold text-2xl text-black my-1">
        Non-Job
      </div>
      <p class="text-black">
        Apakah kamu yakin mau me Non-jobkan talent ini?
      </p>
      <div class="flex justify-center">
        <BButton
          size="md"
          variant="outline-primary"
          class="mr-1"
          style="width: 160.5px"
          @click="$bvModal.hide('modalNonjob')"
        >
          Tidak
        </BButton>
        <BButton
          :disabled="loading"
          size="md"
          variant="primary"
          style="width: 160.5px"
          block
          @click="onFinish"
        >
          Iya
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'

export default {
  name: 'modalNonjob',
  props: {
    idSelected: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      alertError,
      alertSuccess,
    }
  },
  methods: {
    async onFinish() {
      this.loading = true
      const url = `/v1/partner_assignments/talent/${this.idSelected}/unassign`
      await komtimAxiosIns.put(url)
        .then(res => {
          const text = 'Berhasil mengubah data'
          this.alertSuccess(text)
          this.$bvModal.hide('modalNonjob')
        })
        .catch(error => {
          this.alertError(error)
        })
        .finally(() => {
          this.$emit('updated')
          this.loading = false
        })
    },
  },
}
</script>
